import * as React from "react";
import { Text as ChakraText, type TextProps as ChakraTextProps } from "@chakra-ui/react";

export const Text: React.FC<ChakraTextProps> = ({ children, ...rest }) => {
  return <ChakraText {...rest}>{children}</ChakraText>;
};
